export default __webpack_public_path__ + "static/media/nos01.e3e4038b.png";